import { render, staticRenderFns } from "./QualificationsTable.vue?vue&type=template&id=a7a4f3d4&"
import script from "./QualificationsTable.vue?vue&type=script&lang=js&"
export * from "./QualificationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports